import { CreateTimelineForm } from "@/components/practitioner/champVisuel/CreateTimelineForm";
import { ModifyTimelineForm } from "@/components/practitioner/champVisuel/ModifyTimelineForm";
import { SelectTimeline } from "./SelectTimeline";
import {
  Selection,
} from "@/components/practitioner/champVisuel/ChampVisuelParameter";

export default function TabsFormChampVisuel({
  patientId,
  setSelections,
  setSelection,
  selections,
  selection,
  selectionRef,
  updateSelection,
}: {
  patientId: string;
  setSelections: React.Dispatch<React.SetStateAction<Selection[]>>;
  setSelection: (selection: Selection) => void;
  selections: Selection[];
  selection: Selection;
  selectionRef: { current: { ZF: string[]; ZP: string[]; ZV: string[] } };
  updateSelection: () => void;
}) {
  return (
    <div className="mx-auto w-full max-w-4xl">
      <div
        defaultValue="reeducation"
        className="w-full p-3 overflow-auto"
      >
            <div className="flex flex-col items-center w-full space-y-8">
          <FormSelection
            patientId={patientId}
            setSelections={setSelections}
            setSelection={setSelection}
            selections={selections}
            selection={selection}
            selectionRef={selectionRef}
            updateSelection={updateSelection}
          />
        </div>
      </div>
    </div>
  );
}

function FormSelection({
  patientId,
  setSelections,
  selections,
  setSelection,
  selection,
  selectionRef,
  updateSelection,
}: {
  selectionRef: {current: { ZF: string[]; ZP: string[]; ZV: string[] } };
  patientId: string;
  setSelections: React.Dispatch<React.SetStateAction<Selection[]>>;
  selections: Selection[];
  setSelection: (selection: Selection) => void;
  selection: Selection;
  updateSelection: () => void;
}) {
  return (
    <div className="flex flex-col items-center w-full space-y-8">
      <div className="w-full max-w-lg p-6 bg-white border border-gray-200 rounded shadow-md">
        <h2 className="mb-4 text-xl font-semibold text-center">
          Créer une Zone de Travail
        </h2>
        <CreateTimelineForm
          patientId={patientId}
          setSelections={setSelections}
          selectionRef={selectionRef}
          updateSelection={updateSelection}
        />
      </div>
      {/* <div className="w-full max-w-lg p-6 bg-white border border-gray-200 rounded shadow-md">
        <h2 className="mb-4 text-xl font-semibold text-center">
          Selectionner une Zone de Travail
        </h2>
      </div> */}
      <div className="w-full max-w-lg p-6 bg-white border border-gray-200 rounded shadow-md">
        <h2 className="mb-4 text-xl font-semibold text-center">
          Modifier une Zone de Travail
        </h2>
        <SelectTimeline selection={selection} setSelection={setSelection} selections={selections} setSelections={setSelections} />
        <ModifyTimelineForm
          patientId={patientId}
          setSelection={setSelection}
          selection={selection}
          setSelections={setSelections}
          selectionRef={selectionRef}
          updateSelection={updateSelection}
        />
      </div>
    </div>
  );
}
